import dayjs from 'dayjs';

export const getFlexEventDisplayName = (flexEvent = {}) => {
  return flexEvent.FlexEventName || flexEvent.EventName || '(Unnamed Flex Event)';
};

const getFlexEventDateTimeValue = (dateValue, timeValue) => {
  const parsedDateTime = dayjs(`${dateValue || ''} ${timeValue || ''}`);

  return parsedDateTime.isValid() ? parsedDateTime.valueOf() : Number.MAX_SAFE_INTEGER;
};

export const sortFlexEventsForDisplay = (flexEvents = []) => {
  return [...flexEvents].sort((leftEvent, rightEvent) => {
    const startTimeDelta =
      getFlexEventDateTimeValue(leftEvent.FlexDateStart, leftEvent.FlexTimeStart) -
      getFlexEventDateTimeValue(rightEvent.FlexDateStart, rightEvent.FlexTimeStart);

    if (startTimeDelta !== 0) {
      return startTimeDelta;
    }

    const endTimeDelta =
      getFlexEventDateTimeValue(leftEvent.FlexDateEnd, leftEvent.FlexTimeEnd) -
      getFlexEventDateTimeValue(rightEvent.FlexDateEnd, rightEvent.FlexTimeEnd);

    if (endTimeDelta !== 0) {
      return endTimeDelta;
    }

    return getFlexEventDisplayName(leftEvent).localeCompare(getFlexEventDisplayName(rightEvent), undefined, {
      sensitivity: 'base',
    });
  });
};
